import { defineComponent as _defineComponent } from 'vue'
import { BaseCell } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Risk {
  label: string;
  value: string;
}

interface Props {
  risks: Risk[];
  align?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiRiskCell',
  props: {
    risks: null,
    align: { default: 'right' }
  },
  setup(__props: any) {

const { risks } = __props as { risks: Risk[], align: string };



const bulletColor: { [key: string]: NebraskaColors } = {
  LOW: NebraskaColors.riskLow,
  MEDIUM: NebraskaColors.riskMedium,
  HIGH: NebraskaColors.riskHigh
};

function getBulletStyle(risk: Risk) {
  return { backgroundColor: bulletColor[risk.value] };
}

return { __sfc: true,risks, bulletColor, getBulletStyle, BaseCell }
}

})